import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './Drawer.scss';

function Drawer({ direction = 'left', header = '', isOpen = true, setIsOpen = () => {}, children }) {
  const drawerId = useId();
  const headerId = useId();

  const expandCollapseButton = (
    <ButtonWithIcon
      data-e2e="filter-drawer-toggle-button"
      type="borderless"
      sprite={isOpen ? 'NavCollapse' : 'NavExpand'}
      onClick={() => setIsOpen(!isOpen)}
      iconOnly
      size="small"
      className="toggle-panel-button u-els-margin-1o2"
      aria-expanded={isOpen}
      aria-controls={drawerId}>
      {isOpen ? 'Hide Filters' : 'Show Filters'}
    </ButtonWithIcon>
  );

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div className={`drawer-overlay ${isOpen ? 'visible' : ''}`} onClick={() => setIsOpen(false)} aria-hidden={!isOpen} />

      <aside
        id={drawerId}
        data-e2e="drawer-component"
        className={`drawer drawer-${direction} ${isOpen ? 'open' : 'drawer-collapsed'}`}
        aria-labelledby={header ? headerId : undefined}>
        {isOpen && (
          // padding-right added to create space for firefox scrollbar
          <div className="drawer-content u-els-padding-right-3o4 u-els-margin-left-1o2">
            <div className="drawer-content__header">
              <h2 id={headerId} className="u-els-font-size-h4">
                {header}
              </h2>
              {expandCollapseButton}
            </div>
            {children}
          </div>
        )}
        {!isOpen && (
          <>
            {expandCollapseButton}
            <h2 id={headerId} className="drawer-collapsed-header u-els-padding-top-1o2 u-els-font-size-h3">
              {header}
            </h2>
          </>
        )}
      </aside>
    </>
  );
}

Drawer.propTypes = {
  direction: PropTypes.oneOf(['left', 'right']),
  header: PropTypes.node,
  children: PropTypes.node,
};

export default Drawer;
